<template>
  <div>
    <div id="swiper">
      <div class="icon" @click="back">
        <i class="iconfont">&#xe604;</i>
      </div>
      <div class="swiper">
        <swiper :options="swiperOption" ref="mySwiper">
          <swiper-slide v-for="item in slist" :key="item.id">
            <img class="swiper_img" :src="item.imgUrl ? url + item.imgUrl : defaultimg">
          </swiper-slide>
          <div class="swiper-pagination"  slot="pagination"></div>
        </swiper>
      </div>
    </div>
    <div>
      <div class="header-title border-bottom" id="title">
        <p class="title">{{body.title}}</p>
        <span>¥
          <span class="price">{{body.price}}</span>
        </span>
        <p class="header-title-bottom">访问量：<span>{{body.visits}}</span>
          <span class="right">成交量：<span>{{body.turnover}}</span></span>
        </p>
      </div>
      <div class="header-bottom" id="num">
        <div>库存：<span class="stock">{{body.stock}}</span></div>
        <div class="num">
          <span>数量</span>
          <div>
            <input type="button" value="-" @click="handleMinClick">
            <input id="num_info" type="text" v-model="num" @input="inputInfo($event)" >
            <input type="button" value="+" @click="handleAddClick">
          </div>
        </div>
      </div>
      <div class="content">
        <h5><i class="iconfont">&#xe65a;</i>价格规格</h5>
        <p>{{body.spec}}</p>
      </div>
      <div class="content">
        <h5><i class="iconfont">&#xe647;</i>注意事项/交易流程</h5>
        <p>{{body.desc}}</p>
      </div>
      <div class="content">
        <h5><i class="iconfont">&#xe66c;</i>配送方式/取货地址</h5>
        <p>{{body.address}}</p>
      </div>
      <div class="content">
        <h5><i class="iconfont">&#xe60e;</i>联系电话</h5>
        <p>{{body.tel}}</p>
      </div>
      <router-link tag="div" to="/consume" class="consume">
        <p>消费者告知书</p>
        <i class="iconfont">&#xe60f;</i>
      </router-link>
      <router-link tag="div" to="/license" class="consume">
        <p>营业执照</p>
        <i class="iconfont">&#xe60f;</i>
      </router-link>
      <router-link tag="div" to="/service" class="consume">
        <p>服务条款</p>
        <i class="iconfont">&#xe60f;</i>
      </router-link>
      <div class="pic">
        <h5>图文详情</h5>
        <div class="pic_detail" v-html="body.content"></div>
      </div>
    </div>
    <div class="footer">
      <div class="footer-left">
        <i class="iconfont">&#xe611;</i>
        <span @click="handleEnterStore">进入店铺</span>
      </div>
      <div class="footer-right">
        <layer ref="layer"></layer>
        <button @click="Alert">{{addstate}}</button>
        <button class="buy" @click="handleBuyClick">{{buystate}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import wx from 'weixin-js-sdk'
import layer from '@/components/layer/layer'
import url from '@/common/common.js'
export default {
  name: 'DetailContent',
  components: {
    layer
  },
  props: {
    slist: Array,
    body: Object,
    id: String,
    img: String
  },
  data () {
    return {
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
          loop: true
        },
        autoplay: true,
        speed: 400,
        paginationType: 'fraction'
      },
      url,
      defaultimg: '/static/img/defaultimg.jpg', // 默认图片
      num: 1,
      addstate: '加入购物车',
      buystate: '立即购买',
      windowUrl: encodeURIComponent(window.location.href) // 当前页面路由
    }
  },
  methods: {
    back () {
      this.$router.go(-1) // 返回上一层
    },
    handleAddClick () {
      if (!this.getStatus(this.num)) {
        this.num = 1
        alert('请输入数字！')
        return
      } else if (this.num < 0) {
        this.num = 1
        alert('最少输入1！')
        return
      }
      this.num++
    },
    handleMinClick () {
      if (!this.getStatus(this.num)) {
        this.num = 1
        alert('请输入数字！')
      } else if (this.num === 1) {
        this.handleTipClick()
      } else if (this.num <= 1) {
        alert('最少输入1！')
        this.num = 1
      } else {
        this.num--
      }
    },
    handleTipClick () {
      alert('不能再点了哦~')
    },
    /* 加入购物车提交数据 */
    Alert () {
      alert('禁止操作')
      // this.addToCart()
      // this.addstate = '加入中...'
      // this.bus.$emit('loading', true)
      // 反馈
    },
    // 验证
    addToCart () {
      this.axios.get('/ApiDetail/AddCart', {
        params: {
          BuyCount: this.num,
          GoodID: this.id
        }
      }).then(this.postAddInfoSucc)
        .catch(this.postAddInfoFail)
    },
    // 提交
    postAddInfoSucc (res) {
      this.addstate = '加入购物车'
      res = res.data
      if (res.ret) {
        if (res.okInfo === 'succeed') {
          let layer = this.$refs.layer
          this.$refs.layer.open()
          layer.open({
            type: 2,
            content: '加入购物车成功', // 内容
            button: ['去购物车', '继续购物'], // 按钮内容 默认 知道了
            yes () { // 点击确认回调
              layer.open()
            },
            no () { // 点击取消回调
              layer.open()
            }
          })
          this.$router.push({
            path: '/detail/ + item.id'
          })
        } else {
          alert(res.errorInfo)
        }
      }
    },
    postAddInfoFail (err) {
      console.log(err)
    },
    /* 立即购买提交数据 */
    // 验证
    handleBuyClick (res) {
      alert('禁止操作')
      // if (!res.errorInfo) {
      //   this.buystate = '提交中...'
      //   this.$router.push({
      //     path: '/confirm',
      //     query: {
      //       Type: 'ordernow',
      //       goodid: this.id,
      //       buycount: this.num
      //     }
      //   })
      // } else {
      //   alert(res.errorInfo)
      // }
    },
    /* */
    // 验证
    handleEnterStore (res) {
      if (!res.errorInfo) {
        this.$router.push({
          path: '/my_store?shopid=this.body.shop_id',
          query: {
            shopid: this.body.shop_id
          }
        })
      } else {
        alert(res.errorInfo)
      }
    },
    /* 分享 */
    wxShare () {
      // var shareUrl = 'http://localhost:8081/#/detail/' + this.id
      let _this = this
      _this.axios.get('/ApiDetail/GoodShare', {
        params: {
          id: this.id
        }
      }).then(function (res) {
        if (res.data.errorInfo === '') {
          var Data = res.data.data
          // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作
          wx.config({
            debug: false, // 开启调试模式,开发时可以开启
            appId: Data.appid, // 必填，公众号的唯一标识  由接口返回
            timestamp: Data.timestamp, // 必填，生成签名的时间戳 由接口返回
            nonceStr: Data.noncestr, // 必填，生成签名的随机串 由接口返回
            signature: Data.signature, // 必填，签名 由接口返回
            jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline'] // 此处填你所用到的方法
          })
          wx.ready(function () {
            // 分享给朋友
            let temp = _this.body.title
            console.log('##temp##', temp)
            wx.onMenuShareAppMessage({
              title: temp, // 分享标题
              desc: _this.body.desc, // 描述
              // link: encodeURIComponent(location.origin + '/?#/detail/' + this.id), // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              link: window.location.href.split('#')[0] + 'static/redirect.html?shareRedirect=' + encodeURIComponent(location.origin + '/#/detail/' + _this.id),
              imgUrl: 'http://backend.aiyihuo.com/wexinsharelogo.jpg', // 分享图标
              success () {
                // 用户确认分享后执行的回调函数
                Toast('分享成功')
              },
              cancel () {
                // 用户取消分享后执行的回调函数
                Toast('您已取消分享')
              },
              error (res) {
                console.log('分享异常')
                console.log(res)
              }
            })
            // 分享到朋友圈
            wx.onMenuShareTimeline({
              title: temp, // 分享标题
              desc: _this.body.desc, // 描述
              // link: encodeURIComponent(location.origin + '/?#/detail/' + this.id), // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              link: window.location.href.split('#')[0] + 'static/redirect.html?shareRedirect=' + encodeURIComponent(location.origin + '/?#/detail/' + _this.id),
              imgUrl: 'http://backend.aiyihuo.com/wexinsharelogo.jpg', // 分享图标
              success () {
                // 用户确认分享后执行的回调函数
                Toast('分享成功')
              },
              cancel () {
                // 用户取消分享后执行的回调函数
                Toast('您已取消分享')
              }
            })
          })
        } else {
          console.log('###oast(res.data.errorInfo)##', res)
          Toast(res.data.errorInfo)
        }
      }).catch(function (error) {
        console.log('###error##', error)
        Toast(error)
      })
      // console.log('##11this##', _this)
    },
    getStatus (num) {
      var re = /^\d{1,}$/
      var status = true
      if (!re.test(num)) {
        status = false
      }
      return status
    },
    inputInfo () {
      if (!this.getStatus(this.num)) {
        alert('请输入数字！')
        this.num = 1
      } else if (this.num <= 0) {
        alert('最少输入1！')
        this.num = 1
      }
    }
  },
  mounted () {
    this.wxShare()
  }
}
</script>

<style scoped>
.swiper-pagination >>> .swiper-pagination-bullet-active{ background: #ff0135;}
.iconfont{ font-size: 25px;}
.icon{ padding: 10px 5px 5px;}
.swiper >>> .swiper-container{ z-index: 0;}
.swiper_img{ width: 100%; height: 320px;}
.header-title{ margin: 10px 12px; margin-bottom: 0; padding-bottom: 10px;}
.header-title .title{ font-size: 14px; margin-bottom: 5px;}
.header-title span{ font-size: 12px; color: #ff0135;}
.header-title .price{ font-size: 14px;}
.header-title-bottom{ display: flex; justify-content: start; align-items: center; display: block; font-size: 14px; margin-top: 5px; color: #b4b2b2;}
.header-title-bottom span{ font-size: 14px; color: #b4b2b2;}
.right{ float: right;}
.header-bottom{ display: flex; justify-content: space-between; padding: 5px 12px; font-size: 14px; align-items: center; color: #535353; border-bottom: 10px solid #f1f1f1;}
.header-bottom .num{ display: flex; align-items: center;}
.num input{ background-color: #f7f7f7; border: 0; width: 30px; height: 30px;}
.num span{ margin-right: 5px;}
#num .stock{ margin: 0;}
#num span{ margin: 0 20px;}
#num_info{widows: 40px;text-align: center;background: #fff;}
.content .iconfont{ font-size: 20px; font-weight: normal; margin-right: 5px;}
.content{ border-bottom: 10px solid #f1f1f1; padding: 10px 13px;}
.content h5{ margin-bottom: 5px; font-size: 14px; display: flex; align-items: center; font-weight: bold; font-family: 'Arial,Microsoft YaHei';}
.content p{ font-size: 13px; color: #999;}
.consume{ border-bottom: 10px solid #f1f1f1; padding: 10px 13px; display: flex; justify-content: space-between; align-items: center;}
.pic img{ width: 100%;}
.pic h5{ padding: 10px 3px; font-weight: bold; font-size: 14px; font-family: 'Arial,Microsoft YaHei';}
.pic{ padding: 0 10px; margin-bottom: 41px;}
.footer{ display: flex; justify-content: space-between; font-size: 14px; position: fixed; bottom: 0; left: 0; right: 0;}
.footer-left{ width: 40%; line-height: 41px; padding-left: 10px; display: flex; align-items: center; background-color: #fff;}
.footer-left .iconfont{ font-size: 20px; margin-right: 5px;}
.footer-right{ width: 60%; display: flex;}
.footer button{ border: 0; background-color: #ff5d01; color: #fff; height: 41px; width: 50%; display: block; text-decoration: none; text-align: center; line-height: 41px; font-size: 14px; font-family: Arial,"Microsoft YaHei";}
.footer .buy{ background-color: #ff0135;}
.pic_detail >>> img{ width: 100%;}
</style>



// WEBPACK FOOTER //
// src/pages/detail/components/Content.vue